import { render, staticRenderFns } from "./submitAlert.vue?vue&type=template&id=9b4eca0a&"
import script from "./submitAlert.vue?vue&type=script&lang=js&"
export * from "./submitAlert.vue?vue&type=script&lang=js&"
import style0 from "./submitAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports